module.exports = __webpack_public_path__ + "071dbe210d90e9b62f2b5494a6aae49b.svg";